export default __webpack_public_path__ + "static/media/violence.b1966a94.svg";